import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';

function useTIdHandler() {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const authToken = params.get('auth_token');
    if (authToken) {
      const state = uuidv4();
      localStorage.setItem('tbank_state', state);
      localStorage.setItem('tbank_redirect_path', location.pathname);

      const url = `https://id.tbank.ru/auth/authorize?client_id=${process.env.REACT_APP_TID_CLIENT_ID}&redirect_uri=${process.env.REACT_APP_TID_REDIRECT_URI}&auth_token=${authToken}&state=${state}&response_type=code`;

      window.location.href = url;
    }
  }, [location.search]);

  return null;
}

export { useTIdHandler }